import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SvgPersonMail } from '../../../../assets'
import { LayoutAccountEditInformation } from '../common'

export const AccountEditEmailSuccess: FC = () => {
  const { t } = useTranslation()

  return (
    <LayoutAccountEditInformation
      description={t('account-edit.please-confirm-your-email-address')}
      headline={t('account-edit.check-your-email-inbox')}
      image={<SvgPersonMail />}
    />
  )
}
